"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchTranscript = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const Search_1 = __importDefault(require("@material-ui/icons/Search"));
const Close_1 = __importDefault(require("@material-ui/icons/Close"));
const clsx_1 = __importDefault(require("clsx"));
const useTextDebounce = (payload, delay = 500) => {
    const [text, setText] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => {
        const timeOutId = setTimeout(() => setText(payload), delay);
        return () => clearTimeout(timeOutId);
    }, [delay, payload]);
    return text;
};
const useStyles = (0, core_1.makeStyles)({
    notchedOutline: {
        borderColor: 'transparent'
    },
    icon: {
        width: '20px'
    },
    closeIcon: {
        color: '#BDBDBD',
        cursor: 'pointer'
    },
    root: {
        '& ::placeholder': {
            fontSize: '12px',
            color: '#BDBDBD',
            opacity: '1',
            fontWeight: '600'
        }
    }
});
const SearchTranscript = ({ onChange }) => {
    const classes = useStyles();
    const [searchValue, setSearchValue] = (0, react_1.useState)('');
    const debouncedText = useTextDebounce(searchValue);
    (0, react_1.useEffect)(() => {
        onChange(debouncedText);
    }, [debouncedText, onChange]);
    const handleChange = (e) => {
        var _a;
        setSearchValue(((_a = e.target) === null || _a === void 0 ? void 0 : _a.value) || '');
    };
    return (react_1.default.createElement(core_1.Box, { mt: 1, mb: 1, id: "container", style: { backgroundColor: '#FAFAFA', width: '100%' } },
        react_1.default.createElement(core_1.FormControl, { fullWidth: true, id: "form-control" },
            react_1.default.createElement(core_1.OutlinedInput, { fullWidth: true, value: searchValue, classes: { root: classes.root }, id: "search-transcript", margin: "dense", onChange: handleChange, startAdornment: react_1.default.createElement(core_1.InputAdornment, { id: "search-icon", position: "start" },
                    react_1.default.createElement(Search_1.default, { className: classes.icon })), endAdornment: react_1.default.createElement(core_1.InputAdornment, { position: "end" },
                    react_1.default.createElement(Close_1.default, { className: (0, clsx_1.default)(classes.icon, classes.closeIcon), onClick: () => {
                            setSearchValue('');
                            onChange('');
                        } })), placeholder: "Search for anything" }))));
};
exports.SearchTranscript = SearchTranscript;
//# sourceMappingURL=search-transcript.js.map